import React from 'react';
import { Box, Text, Button } from 'pcln-design-system';
import { ExternalLink } from 'pcln-icons';
export var RequestFromType;
(function (RequestFromType) {
  RequestFromType["HOMEPAGE"] = "homePage";
  RequestFromType["POSTBOOKING"] = "travel-itinerary";
})(RequestFromType || (RequestFromType = {}));
var Survey = function (_a) {
  var onClose = _a.onClose,
    requestFrom = _a.requestFrom;
  function handleOpen() {
    if (requestFrom === RequestFromType.HOMEPAGE) {
      window.open('https://pricelineresearch.qualtrics.com/jfe/form/SV_3jXKJkoqkydiAjI?Page=HP', '_blank');
    } else if (requestFrom === RequestFromType.POSTBOOKING) {
      window.open('https://pricelineresearch.qualtrics.com/jfe/form/SV_3jXKJkoqkydiAjI?Page=PB', '_blank');
    }
  }
  function handleClose() {
    onClose();
  }
  return React.createElement(Box, {
    p: 5,
    textAlign: 'center'
  }, React.createElement(Text, {
    fontWeight: 'bold',
    fontSize: 3,
    mb: 3
  }, "Help us Improve Penny!"), React.createElement(Text, {
    fontSize: 1
  }, "Give us 5 minutes and we'll give you", ' ', React.createElement(Text.span, {
    fontWeight: 'bold'
  }, "$10 off Hotel Express Deals*!")), React.createElement(Text, {
    fontSize: 1,
    mb: 2,
    mt: 1
  }, "(limited time offer)"), React.createElement(Text, {
    fontSize: 0,
    color: 'text.light',
    my: 3,
    fontWeight: 'normal'
  }, "*Minimum spend $100"), React.createElement(Box, null, React.createElement(Button, {
    variation: 'fill',
    width: 1,
    mb: 2,
    onClick: handleOpen
  }, "Let's Do It ", React.createElement(ExternalLink, {
    ml: 2
  })), React.createElement(Button, {
    variation: 'subtle',
    width: 1,
    onClick: handleClose
  }, "No Thanks")));
};
export default Survey;